import Vue from 'vue'
import Router from 'vue-router'
// import Clothes from '../views/clothes'
import Signup from '../views/signup'
import SignupStatus from '../views/signup-status'
import AlphaSignUp from '../views/alpha-sign-up'
import AlphaSignUpVerify from '../views/alpha-sign-up-verify'
import UserTerm from '../views/user-term'
import ActivePayment from '../views/active-payment'
import ActivePaymentSuccess from '../views/active-payment/success'
// 邀请有礼页面
import Register from '../views/register-yaoqing/new'
import RegisterResult from '../views/register-yaoqing/result'
import Provision from '../views/register-yaoqing/TheProvisionPage'

// 微信授权页面
import Author from '../views/Author'

// 代理商用户注册
import AgentRegisterUser from '../views/agent-register-user/index'
import AgentRegisterActivation from '../views/agent-register-user/activation/index'

// 新版代理商用户注册
import NewAgentRegisterUser from '../views/newagent-regsiter-user/index.vue'
import NewAgentRegisterActivation from '../views/newagent-regsiter-user/activation/index.vue'
import DownloadPage from '../views/newagent-regsiter-user/download-page/index.vue'
import Activity from '../views/new-activity/index.vue'

import Ticket from '../views/ticket/index.vue'

// 朋友圈分享页面
import BossImage from '../views/boss-image/index.vue'

// 小程序
import Miniprogram from '../views/miniprogram/index.vue'

// import Serve from '../views/newIframe/index.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Activity',
      component: Activity
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/signupstatus',
      name: 'SignupStatus',
      component: SignupStatus
    },
    {
      path: '/sign-up',
      name: 'AlphaSignUp',
      component: AlphaSignUp,
      children: [{
        path: 'verify',
        name: 'AlphaSignUpVerify',
        component: AlphaSignUpVerify
      }, {
        path: 'user-term',
        name: 'UserTerm',
        component: UserTerm
      }]
    },
    {
      path: '/active-payment',
      component: ActivePayment,
      children: [{
        path: 'success',
        name: 'ActivePayment',
        component: ActivePaymentSuccess
      }]
    },
    {
      path: '/register/:code?',
      component: Register
    }, {
      path: '/register-result',
      component: RegisterResult
    }, {
      path: '/author',
      component: Author
    }, { // 邀请有礼注册条款
      path: '/provision',
      component: Provision
    }, {
      path: '/boss-image',
      component: BossImage
    },
    {
      path: '/agent-register/:code?',
      component: AgentRegisterUser
    }, {
      path: '/agent-register-activation',
      component: AgentRegisterActivation
    }, {
      path: '/ticket',
      component: Ticket
    }, {
      path: '/newagent-register/:code?',
      component: NewAgentRegisterUser
    }, {
      path: '/newagent-register-activation',
      component: NewAgentRegisterActivation
    }, {
      path: '/download-page',
      component: DownloadPage
    }, {
      path: '/miniprogram',
      component: Miniprogram
    },
    {
      path: '/new-activity',
      component: Activity
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js